


































import firebase from 'firebase/app'
import 'firebase/functions'
import moment from 'moment'
import Vue from 'vue'
export default
    data: ->
        validating: true
        result:
            event: ''
            tickets: ''
        error: ''
    mounted: ->
        auth = firebase.auth()
        auth.onAuthStateChanged (u) =>
            this.read() if u?
    computed:
        validated: ->
            unless this.result.already_validated? then return ''
            this.$t('validated_already') \
            + ' ' \
            + moment.unix(this.result.already_validated._seconds).format('HH:mm') \
            + ', ' \
            + moment(this.result.already_validated).format('ll')
    methods:
        moment: moment
        read: ->
            code = this.$route.params.code
            endpoint = firebase.functions().httpsCallable('read')
            try r = await endpoint('code': code); this.result = r.data
            catch e then this.error = e.message; console.log e
            finally this.validating = false
